<jqxWindow #form [position]="getFormPos(form,0)" [theme]="theme" [width]="mapWidth" [zIndex]="999"
  [height]="mapHeight" [autoOpen]="true" [showCloseButton]="false" style="margin-top: 24px;">

  <div hidden="true"></div>

  <div class="form">
    <div>
      <app-header #header [buscador]="true" [exportar]="true" [periodo]="true" [filtro]="true" [resetFiltro]="true"
        [seeCheckAlarms]="true" (eventExportar)="onExportar()" (eventFilter)="onAceptar()"
        (eventResetFilter)="onResetFilter()" (eventBuscador)="onBuscar()" (eventCheckAlarms)="onCheckAlarms($event)">
      </app-header>
    </div>
    <div style="width: 100% !important;height: calc(100% - 40px) !important; position: absolute; z-index: 999;">
      <jqxGrid #grid [theme]="theme" [width]="'100%'" [height]="'98%'" [source]="dataAdapter" [columnsresize]="true"
        [sortable]="true" [showrowlines]="false" [showcolumnlines]="true" [columns]="columns" [altrows]="true"
        [filterable]="true" [showstatusbar]="true" [showaggregates]="true" [columnsautoresize]="true"
        [localization]="langGrid" [groupable]="true" [showemptyrow]="false" [statusbarheight]="20"
        (onGroupschanged)="resizeColumns()" [columnsheight]="20" [rowsheight]="20">
      </jqxGrid>
    </div>
  </div>
</jqxWindow>